import { Button, Modal } from "antd";
import React, { useState } from "react";
import { IoMdClose } from "react-icons/io";
import RoleForm from "./RoleForm";

interface RoleModalProps {
  modalOpen: boolean;
  handleClose: () => void;
  handleSubmit: (e: React.FormEvent) => void; // Updated type
  actionType: string;
  id?: string;
  actionItem?: {
    name?: string;
  };
  setExpandedRowKey: (key: string | null) => void;
  linkType?: string;
}

const RoleModal: React.FC<RoleModalProps> = (props) => {
  const {
    modalOpen,
    handleClose,
    handleSubmit,
    actionType,
    id,
    actionItem,
    setExpandedRowKey,
    linkType,
  } = props;
  const [loading, setSubmitLoading] = useState<boolean>(false);

  return (
    <Modal
      title={actionType === "add_role" ? "Create Role" : "Update Role"}
      open={modalOpen}
      onCancel={handleClose}
      footer={null}
    >
      <RoleForm
        close={handleClose}
        actionType={actionType}
        getId={id}
        actionItem={actionItem}
        setLoading={setSubmitLoading}
        setExpandedRowKey={setExpandedRowKey}
        linkType={linkType}
      />
    </Modal>
  );
};

export default RoleModal;
